import { GameConstants } from './../../GameConstants';
import { GameVars } from "./../../GameVars";
import { Button } from "../../utils/Button";
import { Background } from "../background/Background";
import { Table } from "../room/Table";
import { AudioManager } from '../../managers/AudioManager';
import { CharInfoBox } from '../room/CharInfoBox';

export class AdversariesInfoLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Background(this.scene);
        this.add(background);

        const table = new Table(this.scene);
        table.y = 380;
        table.setScale(.9 * GameVars.scaleX, .9);
        this.add(table);

        let backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_menu.png", "btn_menu.png", true, true);
        backButton.scaleX = GameVars.scaleX;
        backButton.onUp(this.onClickBack, this);
        this.add(backButton);



        let midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.x = GameConstants.GAME_WIDTH / 2;
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        let charImg = new CharInfoBox(this.scene, 0, 84, "zombie");
        midContainer.add(charImg);

        charImg = new CharInfoBox(this.scene, -162, 242, "moai");
        midContainer.add(charImg);

        charImg = new CharInfoBox(this.scene, 162, 242, "sloth");
        midContainer.add(charImg);

        charImg = new CharInfoBox(this.scene, -162, 400, "burger-teen");
        midContainer.add(charImg);

        charImg = new CharInfoBox(this.scene, 162, 400, "demon");
        midContainer.add(charImg);

        charImg = new CharInfoBox(this.scene, -162, 558, "monkey");
        midContainer.add(charImg);

        charImg = new CharInfoBox(this.scene, 162, 558, "richMan");
        midContainer.add(charImg);

        this.visible = false;
    }

    private onClickBack(): void {

        AudioManager.playSound("btn_click");

        this.visible = false;
    }
}
